module.exports = __webpack_public_path__ + "img/cask-min.9ba037ad.jpg";